export const PRIVACY_LINK_TEXT = window.jQuery ? $.__('Privacy Policy') : 'Privacy Policy';
export const TERMS_LINK_TEXT = window.jQuery ? $.__('Terms of Service') : 'Terms of Service';
